import React, { useState, useEffect, memo, useCallback } from 'react';
import './HelpRequestsColumn.css';

// Мапа імен користувачів
const userNamesMap = {
  '261': 'Пастушенко Карина',
  '262': "Левицький Мар'ян",
  '263': 'Стецько Андрій',
  '264': 'Сенишин Максим',
  '265': 'Грет Орест',
  '266': 'Козак Дмитро',
  '267': 'Герій Олег',
  '268': 'Островська Катерина',
  '269': 'Павлюк Микола',
  '270': 'Коневич Роман',
  '271': 'Здеорук Вікторія',
  '272': 'Чічкін Ігор',
  '273': 'Рихлінський Руслан',
  '274': 'Віролюбова Анастасія',
  '275': 'Николайчук Дарья',
  '276': 'Єсипович Євген',
  '277': 'Левицький Микита',
  '278': 'Здеорук Олександра',
  '279': 'Петрів Юрій',
  '280': 'Петрів Степан',
  '281': 'Рось Іван',
  '282': 'Бишко Данило',
  '283': 'Сальников Валентин',
  '285': 'Ванденко Максим',
  '286': 'Зеленіков Дмитро',
  '287': 'Сачовська Діана',
  '288': 'Дудар Максим',
  '289': 'Мелих Владислав',
  '1991279261': 'Здеорук Вікторія',
  '08a376410d57a49080f6437a6769e765': 'Пастушенко Карина',
  '6186dc0de930c4489f1cb0263fee3cb9': "Левицький Мар'ян",
  '96936d574385ce2328b697d75cc9ed25': 'Стецько Андрій',
  '7ae8cd52c6b536e7948e163d7eb79be1': 'Сенишин Максим',
  '1c6c7ce92c2e99adb56f8a8743ef2c42': 'Грет Орест',
  '181919b1f3bb927d217d617c4938a885': 'Козак Дмитро',
  'e33d394cde1c7788e4371a5df8c91e7f': 'Герій Олег',
  '888c3b61bb6fc84e462cace3802f5a80': 'Островська Катерина',
  '68cbc91a9357786b674d12f48dbeec5e': 'Павлюк Микола',
  '32478442b5013f8cef0c0a8b07f72dce': 'Коневич Роман',
  'ed863fbec1ec7d6360f62d54942f0655': 'Здеорук Вікторія',
  '8c0d7c9a8853178be96fa60ed8b0298b': 'Чічкін Ігор',
  '7115979f5af389e660bf57e21e10e73a': 'Рихлінський Руслан',
  '9e91681968c552d39c3943cd489de8dd': 'Віролюбова Анастасія',
  '1e9b56558fc6ef081b646ebce9c6d2b7': 'Николайчук Дарья',
  'e90cbdecf165c5b7501e6b52315e0481': 'Єсипович Євген',
  'ecb7033508c49fefc6f146fed1cdbde6': 'Левицький Микита',
  '70d9217877877f35c58a57729a36455e': 'Здеорук Олександра',
  '6b00290e92ccab45f933e1118fbc36f8': 'Петрів Юрій',
  '253db11e2987d6eebe524da08ca3c33a': 'Петрів Степан',
  '19149f434b36af055a1a14ee7dea719d': 'Рось Іван',
  '84053c23a95a2f20256e351a6464f38e': 'Бишко Данило',
  '70bab5c0b422829d5f51dd0c1a6a925e': 'Сальников Валентин',
  'ed2024a4e80d57e488ae8c16d6bc52eb': 'Зеленіков Дмитро',
  '045205e9750e89e7aa8a88eea1e90ba1': 'Сачовська Діана',
  '528295c587f8204164b129b01c68f1f9': 'Дудар Максим',
  '4514b8da7b9d9ae0f612eb3a9316c2ee': 'Мелих Владислав',
  '5a2471cc0559c9bed479ebeaa2810456': 'Ванденко Максим',
  '43481fb68ba4c410a7413a331ae63e2d': 'Шершньов Микита',
  'f26943d7b35dd1070637105cb0783028': 'Гіщинський Любомир',
  '4fee0b2cd341f9ca21a174006703164d': 'Лебідь Роман',
};

const getUserName = (userId) => {
  if (!userId) return 'Невідомий';
  if (userNamesMap[userId]) return userNamesMap[userId];
  if (userNamesMap[String(userId)]) return userNamesMap[String(userId)];
  return userId;
};

const getUserNameFromTaskData = (taskData) => {
  if (!taskData) return 'Невідомий';
  
  if (taskData.User && Array.isArray(taskData.User) && taskData.User.length > 0) {
    const userId = taskData.User[0];
    const name = getUserName(userId);
    if (name !== userId) return name;
  }
  
  if (taskData.userId) {
    const name = getUserName(taskData.userId);
    if (name !== taskData.userId) return name;
  }
  
  if (taskData.who) {
    const name = getUserName(taskData.who);
    if (name !== taskData.who) return name;
  }
  
  if (taskData.userName) return taskData.userName;
  
  return 'Невідомий користувач';
};

// Компонент активного запиту (Нові запити)
const HelpRequestItem = memo(({ request, onTakeHelp, mentorTasks }) => {
  const [timeText, setTimeText] = useState('0:00');
  const userName = getUserNameFromTaskData(request);
  const taskStatus = request.TaskStatus || request.taskStatus || '';
  const taskLink = request.TaskLink || request.taskLink;
  const isInProgress = taskStatus === 'В роботі' || taskStatus === 'В работе' || taskStatus === 'In progress';
  
  // Перевіряємо, чи є відповідь на цей запит (в answerAskHelpTasks)
  // Це перевіряється в батьківському компоненті, тому тут не потрібно дублювати
  
  useEffect(() => {
    const updateTimer = () => {
      if (!request.receivedAt) {
        setTimeText('0:00');
        return;
      }
      
      const startTime = new Date(request.receivedAt);
      const now = new Date();
      const diffMs = now - startTime;
      
      if (diffMs < 0) {
        setTimeText('0:00');
        return;
      }
      
      const totalSeconds = Math.floor(diffMs / 1000);
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      
      if (hours > 0) {
        setTimeText(`${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`);
      } else {
        setTimeText(`${minutes}:${seconds.toString().padStart(2, '0')}`);
      }
    };
    
    updateTimer();
    const interval = setInterval(updateTimer, 1000);
    return () => clearInterval(interval);
  }, [request.receivedAt]);
  
  const handleTakeClick = (e) => {
    e.stopPropagation();
    onTakeHelp(request);
  };
  
  const statusClass = isInProgress ? 'status-in-progress' : 'status-in-queue';
  const statusText = isInProgress ? 'В роботі' : 'В черзі';
  
  return (
    <div className="help-request-card">
      <div className="help-request-info">
        <div className="help-request-user">👤 {userName}</div>
        <div className="help-request-task">📝 {request.TaskName || request.taskName || 'Без назви'}</div>
        {request.projectName && <div className="help-request-project">📁 {request.projectName}</div>}
        <div className="help-request-status">
          <span className={`status-badge ${statusClass}`}>{statusText}</span>
        </div>
        <div className="help-request-time">⏱️ {timeText}</div>
      </div>
      <button className="help-request-take-btn" onClick={handleTakeClick}>Займаюся</button>
    </div>
  );
});

// Компонент відповіді (Взяті в роботу)
const AnsweredRequestItem = memo(({ answer, onStatusChange, onDeclineMentor, currentUserId, archivedTasks, webhooks, mentorTasks }) => {
    const taskData = answer.taskData;
    const taskLink = taskData?.TaskLink || taskData?.taskLink;
    
    // Отримуємо останній статус задачі з webhooks
    const latestWebhook = webhooks.find(w => (w.TaskLink || w.taskLink) === taskLink);
    const currentTaskStatus = latestWebhook?.TaskStatus || latestWebhook?.taskStatus || taskData?.TaskStatus || taskData?.taskStatus || '';
    
    // Отримуємо ментора: спочатку з mentor.json, якщо немає - з answer
    const mentorFromMentorFile = mentorTasks.find(m => (m.TaskLink || m.taskLink) === taskLink);
    const hasMentorInFile = !!mentorFromMentorFile;
    
    // Відображаємо ментора: якщо є в mentor.json - звідти, інакше з answer
    const displayMentorName = hasMentorInFile 
      ? (mentorFromMentorFile.Mentor || mentorFromMentorFile.mentor || getUserName(answer.mentorId))
      : `Займеться: ${getUserName(answer.mentorId)}`;
    
    const mentorId = hasMentorInFile 
      ? (mentorFromMentorFile.MentorId || mentorFromMentorFile.mentorId || answer.mentorId)
      : answer.mentorId;
    
    // Перевірка чи задача заархівована
    const isTaskArchived = () => {
      if (!archivedTasks || !Array.isArray(archivedTasks)) return false;
      return archivedTasks.some(archivedTask => {
        const archivedTaskLink = archivedTask.TaskLink || archivedTask.taskLink;
        return archivedTaskLink === taskLink;
      });
    };
    
    // Неактивні статуси
    const inactiveStatuses = [
      'Скасоване', 'Виконане', 'Відкладене', 'Отложенная',
      'Canceled', 'Completed', 'Postponed', 'Deleted', 'Закрито', 'Завершено'
    ];
    
    const isInactiveStatus = inactiveStatuses.includes(currentTaskStatus);
    const isArchived = isTaskArchived();
    
    // Якщо задача заархівована або має неактивний статус - не показуємо
    if (isArchived || isInactiveStatus) return null;
    
    // Якщо work === 'done' - не показуємо
    if (answer.work === 'done') return null;
    
    const userName = getUserNameFromTaskData(taskData);
    const answerText = answer.answerType === 'now' ? 'Зараз' : `Через ${answer.minutes} хв`;
    
    const [timeLeftText, setTimeLeftText] = useState('');
    const [queueTimerText, setQueueTimerText] = useState('0:00');
    const [workTimerText, setWorkTimerText] = useState('0:00');
    const [currentStatus, setCurrentStatus] = useState(() => {
      if (answer.work === 'active') return 'active';
      return 'in_queue';
    });
    const [showDeclineConfirm, setShowDeclineConfirm] = useState(false);
    
    // Таймер для відповіді "через Х хвилин"
    useEffect(() => {
      if (answer.answerType === 'later' && answer.minutes > 0) {
        const updateTimer = () => {
          const answeredAt = new Date(answer.answeredAt);
          const targetTime = new Date(answeredAt.getTime() + answer.minutes * 60000);
          const now = new Date();
          const remainingMs = targetTime - now;
          
          if (remainingMs > 0) {
            const remainingMinutes = Math.floor(remainingMs / 60000);
            const remainingSeconds = Math.floor((remainingMs % 60000) / 1000);
            setTimeLeftText(`${remainingMinutes}:${remainingSeconds.toString().padStart(2, '0')}`);
          } else {
            setTimeLeftText('Час вийшов!');
          }
        };
        
        updateTimer();
        const interval = setInterval(updateTimer, 1000);
        return () => clearInterval(interval);
      }
    }, [answer.answerType, answer.minutes, answer.answeredAt]);
    
    // Таймер для статусу "В черзі"
    useEffect(() => {
      const getQueueStartTime = () => {
        if (answer.queueStartedAt) {
          return new Date(answer.queueStartedAt);
        }
        return new Date(answer.answeredAt);
      };
      
      const updateQueueTimer = () => {
        const startTime = getQueueStartTime();
        const now = new Date();
        const diffMs = now - startTime;
        
        if (diffMs < 0) {
          setQueueTimerText('0:00');
          return;
        }
        
        const totalSeconds = Math.floor(diffMs / 1000);
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        
        if (hours > 0) {
          setQueueTimerText(`${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`);
        } else {
          setQueueTimerText(`${minutes}:${seconds.toString().padStart(2, '0')}`);
        }
      };
      
      updateQueueTimer();
      const interval = setInterval(updateQueueTimer, 1000);
      return () => clearInterval(interval);
    }, [answer.queueStartedAt, answer.answeredAt]);
    
    // Таймер для статусу "В роботі"
    useEffect(() => {
      if (!answer.activeStartedAt) {
        setWorkTimerText('0:00');
        return;
      }
      
      const updateWorkTimer = () => {
        const startTime = new Date(answer.activeStartedAt);
        const now = new Date();
        const diffMs = now - startTime;
        
        if (diffMs < 0) {
          setWorkTimerText('0:00');
          return;
        }
        
        const totalSeconds = Math.floor(diffMs / 1000);
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        
        if (hours > 0) {
          setWorkTimerText(`${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`);
        } else {
          setWorkTimerText(`${minutes}:${seconds.toString().padStart(2, '0')}`);
        }
      };
      
      updateWorkTimer();
      const interval = setInterval(updateWorkTimer, 1000);
      return () => clearInterval(interval);
    }, [answer.activeStartedAt]);
    
    const handleMoveToWork = async () => {
      const now = new Date().toISOString();
      const updates = {
        work: 'active',
        activeStartedAt: now
      };
      await onStatusChange(answer, 'active', updates);
      setCurrentStatus('active');
    };
    
    const handleMoveToQueue = async () => {
      const now = new Date().toISOString();
      const updates = {
        work: 'in_queue',
        queueStartedAt: now
      };
      await onStatusChange(answer, 'in_queue', updates);
      setCurrentStatus('in_queue');
    };
    
    const handleDeclineClick = (e) => {
      e.stopPropagation();
      setShowDeclineConfirm(true);
    };
    
    const handleConfirmDecline = async () => {
      setShowDeclineConfirm(false);
      await onDeclineMentor(answer);
    };
    
    const handleCancelDecline = () => {
      setShowDeclineConfirm(false);
    };
    
    // Перевіряємо, чи поточний користувач є ментором цієї задачі
    const isCurrentUserMentor = String(mentorId) === String(currentUserId) || 
                                 String(mentorId) === String(localStorage.getItem('userId'));
    
    // Визначаємо клас для рядка ментора
    const mentorClass = hasMentorInFile ? 'mentor-confirmed' : 'mentor-pending';
    const mentorIcon = hasMentorInFile ? '👨‍🏫' : '⏳';
    
    return (
      <div className="answered-request-card">
        {/* Модальне вікно підтвердження відмови */}
        {showDeclineConfirm && (
          <div className="confirm-overlay" onClick={handleCancelDecline}>
            <div className="confirm-modal" onClick={(e) => e.stopPropagation()}>
              <div className="confirm-header">
                <span className="confirm-icon">⚠️</span>
                <span className="confirm-title">Підтвердження</span>
              </div>
              <div className="confirm-body">
                <p>Ви впевнені, що хочете <strong>відмовитись від менторства</strong>?</p>
                <p className="confirm-task-name">Задача: {taskData?.TaskName || taskData?.taskName || 'Без назви'}</p>
                <p className="confirm-warning">Після відмови задача зникне з цього списку.</p>
              </div>
              <div className="confirm-footer">
                <button className="confirm-cancel-btn" onClick={handleCancelDecline}>
                  Скасувати
                </button>
                <button className="confirm-confirm-btn" onClick={handleConfirmDecline}>
                  Так, відмовитись
                </button>
              </div>
            </div>
          </div>
        )}
        
        <div className="answered-request-info">
          <div className="answered-request-user">👤 {userName}</div>
          <div className="answered-request-task">📝 {taskData?.TaskName || taskData?.taskName || 'Без назви'}</div>
          <div className={`answered-request-mentor ${mentorClass}`}>
            {mentorIcon} {displayMentorName}
            {!hasMentorInFile && <span className="mentor-waiting"> (очікує підтвердження)</span>}
          </div>
          <div className="answered-request-answer">⏰ {answerText}</div>
          {answer.answerType === 'later' && timeLeftText && (
            <div className={`answered-request-timer ${timeLeftText === 'Час вийшов!' ? 'expired' : ''}`}>
              ⏳ Залишилось: {timeLeftText}
            </div>
          )}
          
          {/* Статус "В черзі" з таймером */}
          <div className={`status-section ${currentStatus === 'in_queue' ? 'status-active-section' : 'status-inactive-section'}`}>
            <div className="status-header">
              <span className="status-icon">🟡</span>
              <span className="status-name">В черзі</span>
              <span className="status-timer">⏱️ {queueTimerText}</span>
            </div>
          </div>
          
          {/* Статус "В роботі" з таймером */}
          <div className={`status-section ${currentStatus === 'active' ? 'status-active-section' : 'status-inactive-section'}`}>
            <div className="status-header">
              <span className="status-icon">🟢</span>
              <span className="status-name">В роботі</span>
              <span className="status-timer">⏱️ {workTimerText}</span>
            </div>
          </div>
          
          <div className="answered-request-current-status">
            📍 Статус в Планфікс: {currentTaskStatus}
          </div>
        </div>
        
        <div className="answered-request-buttons">
          {isCurrentUserMentor && (
            <>
              {currentStatus === 'in_queue' && (
                <button 
                  className="answered-request-to-work-btn"
                  onClick={handleMoveToWork}
                  title="Перевести в роботу"
                >
                  ⏵ В роботу
                </button>
              )}
              {currentStatus === 'active' && (
                <button 
                  className="answered-request-to-queue-btn"
                  onClick={handleMoveToQueue}
                  title="Перевести в чергу"
                >
                  ⏸ В чергу
                </button>
              )}
              <button 
                className="answered-request-decline-btn"
                onClick={handleDeclineClick}
                title="Відмовитись від менторства"
              >
                ✖ Відмовитись
              </button>
            </>
          )}
          <a 
            href={taskLink} 
            target="_blank" 
            rel="noopener noreferrer"
            className="answered-request-link"
            onClick={(e) => e.stopPropagation()}
          >
            →
          </a>
        </div>
      </div>
    );
  });

// Модальне вікно для відповіді
const AnswerModal = memo(({ isOpen, selectedTask, answerType, answerMinutes, onAnswerTypeChange, onMinutesChange, onSubmit, onClose }) => {
  if (!isOpen || !selectedTask) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  const userName = getUserNameFromTaskData(selectedTask);

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal-content">
        <div className="modal-header">
          <h3>Відповідь на запит допомоги</h3>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        <div className="modal-body">
          <div className="modal-task-info">
            <div><strong>Користувач:</strong> {userName}</div>
            <div><strong>Задача:</strong> {selectedTask.TaskName || selectedTask.taskName || 'Без назви'}</div>
          </div>
          
          <div className="modal-options">
            <label className="modal-option">
              <input
                type="radio"
                name="answerType"
                value="now"
                checked={answerType === 'now'}
                onChange={() => onAnswerTypeChange('now')}
              />
              <span>Займаюся зараз</span>
            </label>
            
            <label className="modal-option">
              <input
                type="radio"
                name="answerType"
                value="later"
                checked={answerType === 'later'}
                onChange={() => onAnswerTypeChange('later')}
              />
              <span>Займуся через</span>
              {answerType === 'later' && (
                <>
                  <input
                    type="number"
                    className="minutes-input"
                    placeholder="хвилин"
                    value={answerMinutes}
                    onChange={(e) => onMinutesChange(e.target.value)}
                    min="1"
                    max="120"
                  />
                  <span>хв</span>
                </>
              )}
            </label>
          </div>
        </div>
        <div className="modal-footer">
          <button className="modal-cancel" onClick={onClose}>Скасувати</button>
          <button className="modal-submit" onClick={onSubmit}>Підтвердити</button>
        </div>
      </div>
    </div>
  );
});

// Головний компонент HelpRequestsColumn
function HelpRequestsColumn({ userId: propUserId }) {
  const [askHelpTasks, setAskHelpTasks] = useState([]);
  const [answerAskHelpTasks, setAnswerAskHelpTasks] = useState([]);
  const [archivedTasks, setArchivedTasks] = useState([]);
  const [webhooks, setWebhooks] = useState([]);
  const [mentorTasks, setMentorTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [collapsed, setCollapsed] = useState(false);
  const [collapsedAnswered, setCollapsedAnswered] = useState(false);
  const [updating, setUpdating] = useState(false);
  
  const [modalState, setModalState] = useState({
    isOpen: false,
    selectedTask: null,
    answerType: 'now',
    answerMinutes: ''
  });

  const currentUserId = propUserId || localStorage.getItem('userId') || '271';

  // Неактивні статуси
  const inactiveStatuses = [
    'Скасоване', 'Виконане', 'Відкладене', 'Отложенная',
    'Canceled', 'Completed', 'Postponed', 'Deleted', 'Закрито', 'Завершено'
  ];

  // Функція для перевірки активності задачі
  const isTaskActive = useCallback((taskData) => {
    if (!taskData) return false;
    
    const taskLink = taskData.TaskLink || taskData.taskLink;
    
    const latestWebhook = webhooks.find(w => (w.TaskLink || w.taskLink) === taskLink);
    const taskStatus = latestWebhook?.TaskStatus || latestWebhook?.taskStatus || taskData.TaskStatus || taskData.taskStatus || '';
    
    const activeStatusesList = ['В роботі', 'В работе', 'In progress', 'В черзі', 'В очереди'];
    const isActiveStatus = activeStatusesList.includes(taskStatus);
    const isNotInactive = !inactiveStatuses.includes(taskStatus);
    
    const isArchived = archivedTasks.some(archivedTask => {
      const archivedTaskLink = archivedTask.TaskLink || archivedTask.taskLink;
      return archivedTaskLink === taskLink;
    });
    
    return isActiveStatus && isNotInactive && !isArchived;
  }, [webhooks, archivedTasks]);

  // Отримання активних запитів (ті, на які ще немає відповіді)
  const getActiveAskHelpTasks = useCallback(() => {
    if (!askHelpTasks || !Array.isArray(askHelpTasks)) return [];
    
    // Отримуємо sessionId задач, на які вже є відповіді
    const answeredSessionIds = answerAskHelpTasks.map(answer => answer.taskData?.sessionId);
    
    return askHelpTasks.filter(task => {
      const isNotAnswered = !answeredSessionIds.includes(task.sessionId);
      return isNotAnswered && isTaskActive(task);
    });
  }, [askHelpTasks, answerAskHelpTasks, isTaskActive]);

  // Отримання активних відповідей (показуємо ВСІ відповіді, навіть якщо ментора ще немає в mentor.json)
  const getActiveAnsweredRequests = useCallback(() => {
    if (!answerAskHelpTasks || !Array.isArray(answerAskHelpTasks)) return [];
    
    return answerAskHelpTasks.filter(answer => {
      // Не показуємо тільки якщо work === 'done'
      if (answer.work === 'done') return false;
      
      const taskData = answer.taskData;
      if (!taskData) return false;
      
      // Перевіряємо активність задачі
      return isTaskActive(taskData);
    });
  }, [answerAskHelpTasks, isTaskActive]);

  // Функція для оновлення статусу work через API
  const updateWorkStatus = async (sessionId, work, additionalData = {}) => {
    try {
      const response = await fetch(`https://hub2.daolog.net/api/update-answer-ask-help-work`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ sessionId, work, ...additionalData })
      });
      
      if (response.ok) {
        const data = await response.json();
        return data.success;
      }
      return false;
    } catch (error) {
      console.error('Error updating work status:', error);
      return false;
    }
  };

  // Функція для зміни статусу (черга/робота)
  const handleStatusChange = async (answer, newStatus, updates) => {
    if (updating) return;
    
    setUpdating(true);
    try {
      const success = await updateWorkStatus(answer.taskData.sessionId, newStatus, updates);
      
      if (success) {
        setAnswerAskHelpTasks(prev => 
          prev.map(a => 
            a.taskData?.sessionId === answer.taskData.sessionId 
              ? { ...a, ...updates, work: newStatus }
              : a
          )
        );
        console.log(`Статус задачі ${answer.taskData.TaskName} змінено на ${newStatus}`);
      } else {
        console.error('Помилка при оновленні статусу');
        alert('Не вдалося оновити статус. Спробуйте ще раз.');
      }
    } catch (error) {
      console.error('Error changing status:', error);
      alert('Помилка при оновленні статусу');
    } finally {
      setUpdating(false);
    }
  };
// Функція для відмови від менторства
const handleDeclineMentor = async (answer) => {
    if (updating) return;
    
    setUpdating(true);
    try {
      const sessionId = answer.taskData?.sessionId;
      
      // 1. Видаляємо задачу з ask-help.json
      const deleteResponse = await fetch(`https://hub2.daolog.net/api/ask-help-task-by-session/${encodeURIComponent(sessionId)}`, {
        method: 'DELETE'
      });
      
      if (!deleteResponse.ok) {
        console.error('Помилка видалення задачі з ask-help.json');
      } else {
        console.log('✅ Задачу видалено з ask-help.json');
      }
      
      // 2. Оновлюємо статус в answer-ask-help.json на 'done'
      const success = await updateWorkStatus(sessionId, 'done');
      
      if (success) {
        setAnswerAskHelpTasks(prev => 
          prev.map(a => 
            a.taskData?.sessionId === sessionId 
              ? { ...a, work: 'done' }
              : a
          )
        );
        
        // 3. Оновлюємо askHelpTasks, щоб прибрати задачу з активних запитів
        await fetchAskHelpTasks();
        
        console.log(`Відмова від менторства у задачі ${answer.taskData.TaskName}`);
      } else {
        console.error('Помилка при відмові від менторства');
        alert('Не вдалося відмовитись від менторства. Спробуйте ще раз.');
      }
    } catch (error) {
      console.error('Error declining mentor:', error);
      alert('Помилка при відмові від менторства');
    } finally {
      setUpdating(false);
    }
  };

  // Функція для додавання відповіді
  const postAnswerAskHelp = async (taskData, answerType, minutes) => {
    try {
      const mentorId = currentUserId;
      const mentorNameValue = getUserName(currentUserId);
      const now = new Date().toISOString();
      
      const response = await fetch(`https://hub2.daolog.net/api/answer-ask-help-task`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          taskData: taskData,
          mentorId: mentorId,
          mentorName: mentorNameValue,
          answerType: answerType,
          minutes: answerType === 'later' ? parseInt(minutes) : 0,
          answeredAt: now,
          work: 'in_queue',
          queueStartedAt: now
        }),
      });
      
      if (response.ok) {
        await fetchAnswerAskHelpTasks();
        return true;
      }
      return false;
    } catch (error) {
      console.error('Error posting answer:', error);
      return false;
    }
  };

  // Завантаження даних
  const fetchAskHelpTasks = async () => {
    try {
      const response = await fetch(`https://hub2.daolog.net/api/ask-help-tasks`);
      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          setAskHelpTasks(data.askHelpTasks || []);
        }
      }
    } catch (error) {
      console.error('Error fetching ask help tasks:', error);
    }
  };

  const fetchAnswerAskHelpTasks = async () => {
    try {
      const response = await fetch(`https://hub2.daolog.net/api/answer-ask-help-tasks`);
      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          setAnswerAskHelpTasks(data.answerAskHelpTasks || []);
        }
      }
    } catch (error) {
      console.error('Error fetching answer ask help tasks:', error);
    }
  };

  const fetchArchivedTasks = async () => {
    try {
      const response = await fetch(`https://hub2.daolog.net/api/archived-tasks`);
      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          setArchivedTasks(data.archivedTasks || []);
        }
      }
    } catch (error) {
      console.error('Error fetching archived tasks:', error);
    }
  };

  const fetchWebhooks = async () => {
    try {
      const response = await fetch(`https://hub2.daolog.net/api/all-webhooks`);
      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          setWebhooks(data.webhooks || []);
        }
      }
    } catch (error) {
      console.error('Error fetching webhooks:', error);
    }
  };

  const fetchMentorTasks = async () => {
    try {
      const response = await fetch(`https://hub2.daolog.net/api/mentor-tasks`);
      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          setMentorTasks(data.mentorTasks || []);
        }
      }
    } catch (error) {
      console.error('Error fetching mentor tasks:', error);
    }
  };

  // Завантаження всіх даних
  const fetchAllData = async () => {
    setLoading(true);
    await Promise.all([
      fetchAskHelpTasks(),
      fetchAnswerAskHelpTasks(),
      fetchArchivedTasks(),
      fetchWebhooks(),
      fetchMentorTasks()
    ]);
    setLoading(false);
  };

  useEffect(() => {
    fetchAllData();
    const interval = setInterval(fetchAllData, 30000);
    return () => clearInterval(interval);
  }, []);

  // Модальне вікно
  const openModal = (task) => {
    setModalState({
      isOpen: true,
      selectedTask: task,
      answerType: 'now',
      answerMinutes: ''
    });
  };

  const closeModal = () => {
    setModalState(prev => ({ ...prev, isOpen: false }));
  };

  const handleAnswerTypeChange = (type) => {
    setModalState(prev => ({ ...prev, answerType: type }));
  };

  const handleMinutesChange = (minutes) => {
    setModalState(prev => ({ ...prev, answerMinutes: minutes }));
  };

  const handleSubmitAnswer = async () => {
    const { selectedTask, answerType, answerMinutes } = modalState;
    if (!selectedTask) return;
    
    if (answerType === 'later' && (!answerMinutes || parseInt(answerMinutes) <= 0)) {
      alert('Будь ласка, введіть кількість хвилин');
      return;
    }
    
    const success = await postAnswerAskHelp(selectedTask, answerType, answerMinutes);
    if (success) {
      closeModal();
    } else {
      alert('Помилка при збереженні відповіді');
    }
  };

  const activeRequests = getActiveAskHelpTasks();
  const answeredRequests = getActiveAnsweredRequests();
  const totalRequests = activeRequests.length + answeredRequests.length;

  if (loading && totalRequests === 0) {
    return <div className="help-requests-column loading">Завантаження...</div>;
  }

  return (
    <div className="help-requests-column">
      <div className="help-requests-header" onClick={() => setCollapsed(!collapsed)}>
        <span className="help-requests-icon">{collapsed ? '▶' : '▼'}</span>
        <span className="help-requests-title">Запити на допомогу ({totalRequests})</span>
      </div>
      
      {!collapsed && (
        <div className="help-requests-content">
          {/* Нові запити */}
          {activeRequests.length > 0 && (
            <div className="help-requests-section">
              <div className="help-requests-subheader">
                <span>Нові запити</span>
                <span className="requests-count">{activeRequests.length}</span>
              </div>
              <div className="help-requests-list">
                {activeRequests.map(request => (
                  <HelpRequestItem
                    key={request.sessionId}
                    request={request}
                    onTakeHelp={openModal}
                    mentorTasks={mentorTasks}
                  />
                ))}
              </div>
            </div>
          )}
          
          {/* Взяті в роботу */}
          {answeredRequests.length > 0 && (
            <div className="answered-requests-section">
              <div 
                className="answered-requests-header" 
                onClick={() => setCollapsedAnswered(!collapsedAnswered)}
                style={{ cursor: 'pointer' }}
              >
                <span className="answered-requests-icon">{collapsedAnswered ? '▶' : '▼'}</span>
                <span className="answered-requests-title">
                  Взяті в роботу ({answeredRequests.length})
                </span>
              </div>
              
              {!collapsedAnswered && (
                <div className="answered-requests-list">
                  {answeredRequests.map((answer, index) => (
                    <AnsweredRequestItem 
                      key={answer.taskData?.sessionId || index} 
                      answer={answer}
                      onStatusChange={handleStatusChange}
                      onDeclineMentor={handleDeclineMentor}
                      currentUserId={currentUserId}
                      archivedTasks={archivedTasks}
                      webhooks={webhooks}
                      mentorTasks={mentorTasks}
                    />
                  ))}
                </div>
              )}
            </div>
          )}
          
          {totalRequests === 0 && (
            <div className="no-requests-message">Немає активних запитів</div>
          )}
        </div>
      )}
      
      <AnswerModal
        isOpen={modalState.isOpen}
        selectedTask={modalState.selectedTask}
        answerType={modalState.answerType}
        answerMinutes={modalState.answerMinutes}
        onAnswerTypeChange={handleAnswerTypeChange}
        onMinutesChange={handleMinutesChange}
        onSubmit={handleSubmitAnswer}
        onClose={closeModal}
      />
    </div>
  );
}

export default HelpRequestsColumn;